import styled from "styled-components";
import { MuiBox } from "../../components";
import { COLORS, responsive } from "../../styles/constants.style";

export const ManageBulkProcessWrapper = styled(MuiBox)`
  &.manage-bulk-process-wrapper {
    margin: 4px 0px 16px;

    .header-right {
      margin-top: 16px;
    }

    .item-row-detail-wrapper {
      border: none;
    }

    .tab-panel-wrapper {
      background-color: ${COLORS.cirrus_white};
      border: 1px solid ${COLORS.cirrus_black3};
      border-radius: 8px;
      margin-top: 24px;
    }

    .dashed-bottom-border {
      border-bottom: 1px dashed ${COLORS.primary_light_blue4};
      margin: 0 16px;

      &:last-child {
        border-bottom: none;
      }
    }

    .search-bottom-divider {
      border-bottom: 1px solid ${COLORS.cirrus_black3};
    }

    .search-process {
      margin: 16px;
    }

    .no-matching-process {
      text-align: center;
      padding: 16px;
    }

    .category-select-container {
      ${responsive.MOBILE`
         margin-left:10px;
          `};
      .category-select {
        .mui-select {
          flex: 1;
        }
      }
    }

    .custom-tab {
      .notification-icon {
        margin-left: 8px;
        background-color: ${COLORS.cirrus_black6};
        color: ${COLORS.cirrus_white};
        border-radius: 8px;
        padding: 3px;
        width: 31px;
        height: 26px;
        text-align: center;
      }

      &.Mui-selected {
        .notification-icon {
          background-color: ${COLORS.primary_dark_blue9};
        }
      }
    }
  }
`;
